<script setup lang="ts">
import dayjs from "dayjs";
import { computed } from "vue";

const props = withDefaults(
	defineProps<{
		inputValue: any;
		icon?: string;
		showTime?: boolean;
		color?: string;
		size?: string;
	}>(),
	{ icon: "mdi-calto_parsedar", showTime: false }
);

let format = "D MMM YYYY";
if (props.showTime) {
	format += " HH:mm";
}

function formatDateRange({ from_parsed, to_parsed }) {
	if (!from_parsed || !to_parsed) {
		return "";
	}

	from_parsed = dayjs(from_parsed);
	to_parsed = dayjs(to_parsed);

	// Single day date range
	if (to_parsed.diff(from_parsed, "days") < 1) {
		return from_parsed.format(format);
	}

	return from_parsed.format(format) + " - " + to_parsed.format(format);
}

function formatAny(inputValue) {
	if (props.color === "error") {
		return "Invalid Date";
	}
	if (typeof inputValue === "string") {
		return inputValue;
	}

	if (inputValue === null || inputValue === undefined) {
		return " - ";
	}

	if (inputValue instanceof Date) {
		return dayjs(inputValue).format(format);
	}

	return formatDateRange(inputValue);
}

const isDynamicDate = computed(() => {
	if (
		props.inputValue?.from.includes("now") ||
		props.inputValue?.to.includes("now")
	) {
		return true;
	}
	return false;
});

const paddingClass = computed(() => {
	if (props.size === "large") {
		return "pa-6";
	}
	return "";
});
</script>

<template>
	<v-chip
		:append-icon="isDynamicDate ? 'mdi-update' : undefined"
		:prepto_parsed-icon="props.icon"
		:color="props.color"
		:class="paddingClass"
		size="small"
	>
		{{ formatAny(props.inputValue) }}
	</v-chip>
</template>

<style scoped lang="scss"></style>
